import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit, Optional } from '@angular/core';
import { RouterModule } from '@angular/router';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ToastComponent } from './toast.component';
import { ToastEvent, ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toaster',
  standalone: true,
  imports: [
    RouterModule,ToastComponent],
  styles: [],
  template: `<div class="toaster position-fixed bottom-0 end-0 px-3 py-2 m-16" style="z-index: 10000;">
  @for (toast of currentToasts; track toast; let i = $index) {
    <div>
      <app-toast
        [type]="toast.type"
        [title]="toast.title"
        [message]="toast.message"
        (disposeEvent)="dispose(i)"
      ></app-toast>
    </div>
  }
</div>`,
})
export class ToasterComponent implements OnInit {
  currentToasts: ToastEvent[] = [];

  constructor(
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subscribeToToasts();
  }

  subscribeToToasts() {
    this.toastService.toastEvents.subscribe((toasts) => {
      const currentToast: ToastEvent = {
        type: toasts.type,
        title: toasts.title,
        message: toasts.message,
      };
      this.currentToasts.push(currentToast);
      this.cdr.detectChanges();
    });
  }

  dispose(index: number) {
    this.currentToasts.splice(index, 1);
    this.cdr.detectChanges();
  }
}
